import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Load Sentry off the critical path (separate chunk); start in parallel with bootstrap.
const sentryReady = environment.production
  ? import('./sentry-init').then((m) => {
      m.initSentry();
      return m;
    })
  : null;

platformBrowser()
  .bootstrapModule(AppModule)
  .catch(async (err: unknown) => {
    console.error('[Bootstrap Error] Angular module failed to bootstrap:', err);
    try {
      const sentry = await sentryReady;
      sentry?.reportBootstrapFailure(err);
    } catch {
      // Sentry load/report must not hide the original bootstrap failure.
    }
    throw err;
  });
